<template>
   <div class="date-content">
      <span class="left" @click="onGoBefore" :class="beforeClass">
         <span data-v-578dd452="" class="iconfont iconxiangzuo" style="font-size: 0.3rem;"></span>
         <!-- <span class="iconfont icon">&#xe604;</span> -->
         前一天
      </span>
      <div class="date">
         <!-- <span class="iconfont icon">&#xe669;</span> -->
         <van-icon name="calendar-o" class="icon" />
         <span v-cloak>{{ ClassDate | dateToStr }}</span>
      </div>
      <span class="right" @click="onGoAfter">
         后一天
         <!-- <span class="iconfont icon">&#xe652;</span> -->
         <span data-v-578dd452="" class="iconfont iconxiangyou" style="font-size: 0.3rem;"></span>
      </span>
   </div>
</template>

<script>
export default {
   props: {
      ClassDate: {
         type: Date,
         required: true,
         default: () => new Date()
      },
      minDate: Date
   },
   computed: {
      beforeClass() {
         let classArr = [];
         const beforeDay = new Date(
            this.ClassDate.getTime() - 24 * 60 * 60 * 1000
         );
         if (this.minDate && this.minDate > beforeDay) {
            classArr.push('disabled');
         }
         return classArr;
      }
   },
   methods: {
      // 前一天
      onGoBefore() {
         const beforeDay = new Date(
            this.ClassDate.getTime() - 24 * 60 * 60 * 1000
         );
         if (this.minDate && this.minDate > beforeDay) {
            return;
         }
         this.$emit('onGoBefore', beforeDay);
      },
      // 后一天
      onGoAfter() {
         this.$emit('onGoAfter', new Date(
            this.ClassDate.getTime() + 24 * 60 * 60 * 1000
         ));
      },
   }
}
</script>

<style lang="less" scoped>
.date-content {
   width: 100%;
   height: 1rem;
   line-height: 1rem;
   color: #ffb870;
   background-color: #fff;
   font-size: 0.4rem;
   display: flex;
   justify-content: space-between;
   box-sizing: border-box;
   padding: 0 0.2rem;
   z-index: 2;

   .left .icon {
      font-size: 0.32rem;
      margin-right: 0.1rem;
      position: relative;
      font-weight: bold;
   }

   .date .icon {
      font-size: 0.45rem;
      position: relative;
      right: 0.1rem;
   }

   .right .icon {
      font-size: 0.32rem;
      margin-left: 0.1rem;
      position: relative;
      font-weight: bold;
   }

   .disabled {
      color: #919191;
   }
}
</style>